import * as React from "react";
const IcoLocation = () => (
  <svg
    width={"100%"}
    height={"100%"}
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="surface9431">
      <path
        id="Vector"
        d="M7 0C3.14014 0 0 3.14082 0 7C0 12.144 6.33565 15.9296 6.60571 16.0889C6.72724 16.1605 6.86362 16.1963 7 16.1963C7.13638 16.1963 7.27276 16.1605 7.39429 16.0889C7.66435 15.9296 14 12.144 14 7C14 3.14082 10.8599 0 7 0ZM7 8.55556C6.14188 8.55556 5.44444 7.85812 5.44444 7C5.44444 6.14188 6.14188 5.44444 7 5.44444C7.85812 5.44444 8.55556 6.14188 8.55556 7C8.55556 7.85812 7.85812 8.55556 7 8.55556Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default IcoLocation;
